<template>
    <div class="form-content">
        <el-form :model="createCourseForm" label-width="150px" :rules="rules" ref="createCourseForm"
                 class="demo-ruleForm">
            <el-form-item label="课程名称" prop="name" class="other-item">
                <el-input ref="name" v-model="createCourseForm.name"></el-input>
            </el-form-item>
            <el-form-item label="课程分类" prop="class" class="other-item">
                <el-cascader v-model="createCourseForm.class" style="width: 300px" size="medium" :props="keyObj"
                             :options="courseClass" ref="specObj" clearable placeholder="请选择分类"
                             @change="changeCourseClass"></el-cascader>
            </el-form-item>
            <el-form-item label="课程封面" prop="cover" class="other-item">
                <el-upload
                        class="cover-uploader"
                        action="course/uploadImage"
                        :headers="headerParam"
                        :show-file-list="false"
                        :on-success="handleCoverSuccess"
                        :before-upload="beforeCoverUpload">
                    <div class="inner-box">
                        <div class="inner-content">
                            <i class="el-icon-plus"></i>
                            <span class="inner-text">上传封面</span>
                        </div>
                    </div>
                    <div class="cover" v-if="createCourseForm.cover">
                        <img :src="createCourseForm.cover">
                        <div class="cover-bottom">重新上传</div>
                    </div>
                    <span class="item-txt-tip">*建议使用宽356像素*高200像素的图片</span>
                </el-upload>
            </el-form-item>
            <el-form-item label="考核内容" prop="intro" class="other-item">
                <el-input ref="intro" type="textarea" :rows="5" v-model="createCourseForm.intro"></el-input>
            </el-form-item>
            <el-form-item label="职业名称" prop="job_title" class="other-item">
                <el-input ref="job_title" v-model="createCourseForm.job_title"></el-input>
            </el-form-item>
            <el-form-item label="职业等级" prop="job_level" class="other-item">
                <el-input ref="job_level" v-model="createCourseForm.job_level"></el-input>
            </el-form-item>
            <el-form-item label="鉴定方式、鉴定时间" prop="name" class="other-item">
                <el-input ref="appraisal_way_time" type="textarea" :rows="5" v-model="createCourseForm.appraisal_way_time"></el-input>
            </el-form-item>
            <el-form-item label="课程排序" prop="sort" class="other-item">
                <el-popover placement="right" trigger="click">
                    <div class="tooltipTxt">排序数值在1~255之间，数值越小，课程展示越靠前</div>
                    <el-input-number v-model="createCourseForm.sort" slot="reference" style="width: 500px;"
                                     class="c-input-width-80"
                                     ref="sort"
                                     :precision="0" :controls="false" :min="0" :max="255"></el-input-number>
                </el-popover>
            </el-form-item>
            <div class="form-title">
                <div class="item-text">鉴定概要</div>
            </div>
            <div class="add-btn">
                <div class="btn-box" @click="addKnowledgeTitle">
                    <i class="el-icon-plus"></i>添加内容
                </div>
            </div>
            <el-form-item label="01理论知识">
                <el-table
                        class="knowledgeTable"
                        ref="knowledgeTable"
                        :data="createCourseForm.knowledge"
                        style="width: 100%;margin-bottom: 20px;"
                        row-key="id"
                        border
                        default-expand-all
                        :header-cell-style="{fontWeight: 'normal', color: '#333', background: '#EEEEEE',height:'50px',padding:'0 120px 0 60px',borderRight:'none'}"
                        :cell-style="{fontSize: '12px',color: '#333',height:'50px',padding:'0 100px 0 60px',borderRight:'none'}"
                        :tree-props="{children: 'children'}">
                    <el-table-column prop="name" min-width="100%" label="内容" align="left"></el-table-column>
                    <el-table-column label="操作" min-width="50%" align="right">
                        <template slot-scope="scope">
                            <el-button type="text" size="small"
                                       style="color: #666666;font-size: 16px;margin-right: 36px;"
                                       v-if="scope.row.level < 2"
                                       @click="addKnowledgeChild(scope.row)">添加子分类
                            </el-button>
                            <el-button type="text" size="small" style="font-size: 16px;"
                                       @click="editKnowledgeTitle(scope.row)">编辑
                            </el-button>
                            <el-button type="text" style="color: #EB1515;font-size: 16px;" size="small"
                                       @click="deleteKnowledgeRow(scope.row)">删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form-item>
            <div class="add-btn">
                <div class="btn-box" @click="addMajorTitle">
                    <i class="el-icon-plus"></i>添加内容
                </div>
            </div>
            <el-form-item label="02专业技能">
                <el-table
                        class="knowledgeTable"
                        ref="knowledgeTable"
                        :data="createCourseForm.major"
                        style="width: 100%;margin-bottom: 20px;"
                        row-key="id"
                        border
                        default-expand-all
                        :header-cell-style="{fontWeight: 'normal', color: '#333', background: '#EEEEEE',height:'50px',padding:'0 120px 0 60px',borderRight:'none'}"
                        :cell-style="{fontSize: '12px',color: '#333',height:'50px',padding:'0 100px 0 60px',borderRight:'none'}"
                        :tree-props="{children: 'children'}">
                    <el-table-column prop="name" min-width="100%" label="内容" align="left"></el-table-column>
                    <el-table-column label="操作" min-width="50%" align="right">
                        <template slot-scope="scope">
                            <el-button type="text" size="small"
                                       style="color: #666666;font-size: 16px;margin-right: 36px;"
                                       v-if="scope.row.level < 2"
                                       @click="addMajorChild(scope.row)">添加子分类
                            </el-button>
                            <el-button type="text" size="small" style="font-size: 16px;"
                                       @click="editMajorTitle(scope.row)">编辑
                            </el-button>
                            <el-button type="text" style="color: #EB1515;font-size: 16px;" size="small"
                                       @click="deleteMajorRow(scope.row)">删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form-item>
            <div class="form-title">
                <div class="item-text">鉴定内容</div>
            </div>
            <el-form-item label="理论知识鉴定内容">
                <vue-tinymce :setting="setting"
                             v-model="createCourseForm.appraisal_content.theoretical_knowledge_content"></vue-tinymce>
            </el-form-item>
            <el-form-item label="专业技能考核内容">
                <vue-tinymce :setting="setting"
                             v-model="createCourseForm.appraisal_content.professional_skill_content"></vue-tinymce>
            </el-form-item>
            <el-form-item>
                <el-button @click="goBack('createCourseForm')">返回</el-button>
                <el-button type="primary" class="next-stepBtn" @click="submitForm('createCourseForm')">下一步</el-button>
            </el-form-item>
        </el-form>
        <CourseInsideTitle v-if="dialogVisible" :dialogVisible="dialogVisible" :title="dialogTitle"
                           :dialogLevel="dialogLevel" :editTitle="editTitle"
                           @closeDialog="closeDialog" @saveData="saveData"></CourseInsideTitle>
    </div>
</template>

<script>
    import {cateCates, courseUploadImage, course} from '@/utils/apis'
    import CourseInsideTitle from "../../../components/admin/courseManage/CourseInsideTitle";

    export default {
        name: "courseForm",
        components: {
            CourseInsideTitle
        },
        props: ['courseId'],
        data() {
            let checkCover = (rule, value, callback) => {
                if (this.imageUrl === '') {
                    callback(new Error('请上传课程封面！'));
                } else {
                    callback();
                }
            };
            return {
                dialogVisible: false,
                dialogTitle: "",//弹框的标题
                dialogType: "",//判断类型，鱼骨图、知识图谱、上传资料
                dialogLevel: "",
                editTitle: "",
                editId: "",
                knowledgeRowIndex: 0,
                knowledgeChildIndex: 0,
                knowledgeEndIndex: 0,
                majorRowIndex: 0,
                majorChildIndex: 0,
                majorEndIndex: 0,
                createCourseForm: {
                    type: 1,
                    name: '',
                    class: [],
                    classify_id: '',
                    intro: '',
                    cover: '',
                    job_title: '',
                    job_level: '',
                    appraisal_way_time: '',
                    sort: '',
                    knowledge: [],
                    major: [],
                    appraisal_content: {
                        theoretical_knowledge_content: '',
                        professional_skill_content: '',
                    }
                },
                rules: {
                    cover: [
                        {validator: checkCover, trigger: 'change'}
                    ],
                },
                courseClass: [],
                keyObj: {
                    label: 'name',
                    value: 'id'
                },
                headerParam: {
                    Authorization: localStorage.getItem('adminToken') || ''
                },
                setting: {
                    menubar: false,
                    plugins: "lists, advlist,emoticons,fullscreen,table,insertdatetime,wordcount,image",
                    toolbar: [
                        'undo redo | styleselect | bold italic underline strikethrough|fontselect fontsizeselect formatselect|alignleft aligncenter alignright|bullist numlist|',
                        'image emoticons forecolor backcolor insertdatetime wordcount|table tabledelete|fullscreen|'
                    ],
                    language: 'zh_CN', //本地化设置
                    height: 300
                },
            }
        },
        created() {
            this.getSpecializedList();
        },
        methods: {
            //专业分类
            getSpecializedList() {
                let params = {
                    type: '1'
                }
                cateCates(params).then((res) => {
                    if (res.code == 200) {
                        this.courseClass = res.data;
                        if (this.courseId != undefined) {
                            this.getEditData();
                        }
                    }
                })
            },
            getEditData() {
                let param = {
                    id: this.courseId
                }
                course(param).then((res) => {
                    if (res.code == 200) {
                        this.createCourseForm.name = res.data.name;
                        this.createCourseForm.classify_id = res.data.classify_id;
                        this.getClass(this.createCourseForm.classify_id);
                        this.createCourseForm.cover = res.data.cover;
                        this.createCourseForm.intro = res.data.intro;
                        this.createCourseForm.job_title = res.data.job_title;
                        this.createCourseForm.job_level = res.data.job_level;
                        this.createCourseForm.appraisal_way_time = res.data.appraisal_way_time;
                        this.createCourseForm.sort = res.data.sort;
                        this.createCourseForm.knowledge = res.data.appraisal_outline.theoretical_knowledge;
                        this.createCourseForm.major = res.data.appraisal_outline.professional_skill;
                        this.createCourseForm.appraisal_content = res.data.appraisal_content;
                    }
                }).catch((err) => {
                    console.error(err)
                })
            },
            getClass(id) {
                this.createCourseForm.class = [];
                this.courseClass.forEach(item => {
                    if (item.id == id) {
                        this.createCourseForm.class = [item.id]
                    } else {
                        if (item.children) {
                            item.children.forEach(item1 => {
                                if (item1.id == id) {
                                    this.createCourseForm.class = [item.id, item1.id]
                                }
                            })
                        }
                    }
                })
            },
            changeCourseClass(val) {
                this.createCourseForm.classify_id = this.createCourseForm.class[this.createCourseForm.class.length - 1]
            },
            handleCoverSuccess(res, file) {
                if (res.code === 200) {
                    this.createCourseForm.cover = res.data[0]; //无域名
                    this.$message.success('上传成功')
                } else {
                    this.$message.error('上传失败，请稍后再试~')
                }
            },
            beforeCoverUpload(file) {
                const isSize = new Promise((resolve, reject) => {
                    const width = 356;
                    const height = 200;
                    const _URL = window.URL || window.webkitURL;
                    const img = new Image();
                    img.onload = () => {
                        const valid = img.width === width && img.height === height;
                        valid ? resolve() : reject();
                    };
                    img.src = _URL.createObjectURL(file);
                }).then(() => {
                        return file;
                    }, () => {
                        this.$message.warning('图片尺寸限制为356px x 200px');
                        return Promise.reject();
                    },
                );
                return isSize;
            },
            getId(list, arr) {
                list.forEach(ele => {
                    arr.push(ele.id);
                    if (ele.children && ele.children.length > 0) {
                        this.getId(ele.children, arr)
                    }
                    if (ele.children.children && ele.children.children.length > 0) {
                        this.getId(ele.children, arr)
                    }
                })
                return arr;
            },
            addKnowledgeTitle() {
                this.dialogTitle = '理论知识';
                this.dialogVisible = true;
                this.dialogType = 1;
                this.dialogLevel = 1;
            },
            addMajorTitle() {
                this.dialogTitle = '专业知识';
                this.dialogVisible = true;
                this.dialogType = 2;
                this.dialogLevel = 1;
            },
            expandKnowledge(row, val) {
                if (row.children.length === 0) return;
                this.$refs.knowledgeTable.toggleRowExpansion(row, val);
                row.expand = val;
            },
            addKnowledgeChild(row) {
                this.dialogTitle = '理论知识';
                this.dialogVisible = true;
                this.dialogType = 1;
                this.dialogLevel = row.level === 1 ? 2 : 3;
                this.getKnowlegeId(row);
            },
            editKnowledgeTitle(row) {
                this.dialogTitle = '理论知识';
                this.dialogVisible = true;
                this.dialogType = 1;
                this.dialogLevel = row.level;
                this.editTitle = row.name;
                this.editId = row.id;
                this.getKnowlegeId(row);
            },
            deleteKnowledgeRow(row) {
                this.dialogType = 1;
                this.dialogLevel = row.level;
                this.getKnowlegeId(row);
                if (row.level === 1) {
                    this.createCourseForm.knowledge.splice(this.knowledgeRowIndex, 1);
                } else if (row.level === 2) {
                    this.createCourseForm.knowledge[this.knowledgeRowIndex].children.splice(this.knowledgeChildIndex, 1);
                } else {
                    this.createCourseForm.knowledge[this.knowledgeRowIndex].children[this.knowledgeChildIndex].children.splice(this.knowledgeEndIndex, 1);
                }
            },
            saveEditKnowledge(obj) {
                if (this.dialogLevel == 1) {
                    this.createCourseForm.knowledge[this.knowledgeRowIndex].name = obj.name;
                } else if (this.dialogLevel == 2) {
                    this.createCourseForm.knowledge[this.knowledgeRowIndex].children[this.knowledgeChildIndex].name = obj.name;
                } else {
                    this.createCourseForm.knowledge[this.knowledgeRowIndex].children[this.knowledgeChildIndex].children[this.knowledgeEndIndex].name = obj.name;
                }
            },
            saveKnowledgeTitle(obj) {
                let arr = [];
                let maxId = 0;
                if (this.createCourseForm.knowledge.length > 0) {
                    arr = this.getId(this.createCourseForm.knowledge, arr);
                    maxId = Math.max(...arr);
                }
                let newId = maxId + 1;
                obj.id = newId;
                if (this.dialogLevel == 1) {
                    obj.level = 1;
                    obj.parent_id = 0;
                    this.createCourseForm.knowledge.push(obj);
                } else if (this.dialogLevel == 2) {
                    obj.level = 2;
                    obj.parent_id = this.createCourseForm.knowledge[this.knowledgeRowIndex].id;
                    this.createCourseForm.knowledge[this.knowledgeRowIndex].expand = true;
                    this.createCourseForm.knowledge[this.knowledgeRowIndex].children.push(obj);
                } else {
                    obj.level = 3;
                    obj.parent_id = this.createCourseForm.knowledge[this.knowledgeRowIndex].children[this.knowledgeChildIndex].id;
                    this.createCourseForm.knowledge[this.knowledgeRowIndex].children[this.knowledgeChildIndex].expand = true;
                    this.createCourseForm.knowledge[this.knowledgeRowIndex].children[this.knowledgeChildIndex].children.push(obj);
                }
            },
            getKnowlegeId(row) {
                if (row.level === 1) {
                    this.knowledgeRowIndex = this.createCourseForm.knowledge.indexOf(row);
                } else if (row.level === 2) {
                    this.createCourseForm.knowledge.forEach(item => {
                        if (item.id == row.parent_id) {
                            this.knowledgeRowIndex = this.createCourseForm.knowledge.indexOf(item);
                        }
                    })
                    this.knowledgeChildIndex = this.createCourseForm.knowledge[this.knowledgeRowIndex].children.indexOf(row);
                } else {
                    let len = this.createCourseForm.knowledge.length;
                    for (let i = 0; i < len; i++) {
                        for (let j = 0; j < this.createCourseForm.knowledge[i].children.length; j++) {
                            if (this.createCourseForm.knowledge[i].children[j].id == row.parent_id) {
                                this.knowledgeRowIndex = i;
                                this.knowledgeChildIndex = j;
                                this.knowledgeEndIndex = this.createCourseForm.knowledge[i].children[j].children.indexOf(row);
                            }
                        }
                    }
                }
            },
            addMajorChild(row) {
                this.dialogTitle = '理论知识';
                this.dialogVisible = true;
                this.dialogType = 2;
                this.dialogLevel = row.level === 1 ? 2 : 3;
                this.getMajorId(row);
            },
            editMajorTitle(row) {
                this.dialogTitle = '理论知识';
                this.dialogVisible = true;
                this.dialogType = 2;
                this.dialogLevel = row.level;
                this.editTitle = row.name;
                this.editId = row.id;
                this.getMajorId(row);
            },
            deleteMajorRow(row) {
                this.dialogType = 2;
                this.dialogLevel = row.level;
                this.getMajorId(row);
                if (row.level === 1) {
                    this.createCourseForm.major.splice(this.majorRowIndex, 1);
                } else if (row.level === 2) {
                    this.createCourseForm.major[this.majorRowIndex].children.splice(this.majorChildIndex, 1);
                } else {
                    this.createCourseForm.major[this.majorRowIndex].children[this.majorChildIndex].children.splice(this.majorEndIndex, 1);
                }
            },
            saveMajorledge(obj) {
                if (this.dialogLevel == 1) {
                    this.createCourseForm.major[this.majorRowIndex].name = obj.name;
                } else if (this.dialogLevel == 2) {
                    this.createCourseForm.major[this.majorRowIndex].children[this.majorChildIndex].name = obj.name;
                } else {
                    this.createCourseForm.major[this.majorRowIndex].children[this.majorChildIndex].children[this.majorEndIndex].name = obj.name;
                }
            },
            saveMajorTitle(obj) {
                let arr = [];
                let maxId = 0;
                if (this.createCourseForm.major.length > 0) {
                    arr = this.getId(this.createCourseForm.major, arr);
                    maxId = Math.max(...arr);
                }
                let newId = maxId + 1;
                obj.id = newId;
                if (this.dialogLevel == 1) {
                    obj.level = 1;
                    obj.parent_id = 0;
                    this.createCourseForm.major.push(obj);
                } else if (this.dialogLevel == 2) {
                    obj.level = 2;
                    obj.parent_id = this.createCourseForm.major[this.majorRowIndex].id;
                    this.createCourseForm.major[this.majorRowIndex].expand = true;
                    this.createCourseForm.major[this.majorRowIndex].children.push(obj);
                } else {
                    obj.level = 3;
                    obj.parent_id = this.createCourseForm.major[this.majorRowIndex].children[this.majorChildIndex].id;
                    this.createCourseForm.major[this.majorRowIndex].children[this.majorChildIndex].expand = true;
                    this.createCourseForm.major[this.majorRowIndex].children[this.majorChildIndex].children.push(obj);
                }
            },
            getMajorId(row) {
                if (row.level === 1) {
                    this.majorRowIndex = this.createCourseForm.major.indexOf(row);
                } else if (row.level === 2) {
                    this.createCourseForm.major.forEach(item => {
                        if (item.id == row.parent_id) {
                            this.majorRowIndex = this.createCourseForm.major.indexOf(item);
                        }
                    })
                    this.majorChildIndex = this.createCourseForm.major[this.majorRowIndex].children.indexOf(row);
                } else {
                    let len = this.createCourseForm.major.length;
                    for (let i = 0; i < len; i++) {
                        for (let j = 0; j < this.createCourseForm.major[i].children.length; j++) {
                            if (this.createCourseForm.major[i].children[j].id == row.parent_id) {
                                this.majorRowIndex = i;
                                this.majorChildIndex = j;
                                this.majorEndIndex = this.createCourseForm.major[i].children[j].children.indexOf(row);
                            }
                        }
                    }
                }
            },
            saveData(data) {
                let obj = {
                    name: data,
                    expand: false,
                    children: []
                }
                if (this.dialogType == 1) {
                    if (this.editId !== '') {
                        this.saveEditKnowledge(obj)
                    } else {
                        this.saveKnowledgeTitle(obj)
                    }
                } else if (this.dialogType == 2) {
                    if (this.editId !== '') {
                        this.saveMajorledge(obj)
                    } else {
                        this.saveMajorTitle(obj)
                    }
                }
                this.closeDialog(false);
            },
            closeDialog(val) {
                this.dialogTitle = '';
                this.dialogVisible = val;
                this.dialogType = '';
                this.dialogLevel = '';
                this.editTitle = '';
                this.editId = '';
            },
            async submitForm(formName) {
                let isErrNum = 0;
                if (this.createCourseForm.name == '') {
                    this.$refs.name.$el.classList.add('isError');
                    isErrNum = 1;
                } else {
                    this.$refs.name.$el.classList.remove('isError');
                }
                if (this.createCourseForm.classify_id == '') {
                    this.$refs.specObj.$el.classList.add('isError');
                    isErrNum = 1;
                } else {
                    this.$refs.specObj.$el.classList.remove('isError');
                }
                if (this.createCourseForm.intro == '') {
                    this.$refs.intro.$el.classList.add('isError');
                    isErrNum = 1;
                } else {
                    this.$refs.intro.$el.classList.remove('isError');
                }
                if (this.createCourseForm.job_title == '') {
                    this.$refs.job_title.$el.classList.add('isError');
                    isErrNum = 1;
                } else {
                    this.$refs.job_title.$el.classList.remove('isError');
                }
                if (this.createCourseForm.job_level == '') {
                    this.$refs.job_level.$el.classList.add('isError');
                    isErrNum = 1;
                } else {
                    this.$refs.job_level.$el.classList.remove('isError');
                }
                if (this.createCourseForm.appraisal_way_time == '') {
                    this.$refs.appraisal_way_time.$el.classList.add('isError');
                    isErrNum = 1;
                } else {
                    this.$refs.appraisal_way_time.$el.classList.remove('isError');
                }
                if (this.createCourseForm.sort == '') {
                    this.$refs.sort.$el.classList.add('isError');
                    isErrNum = 1;
                } else {
                    this.$refs.sort.$el.classList.remove('isError');
                }
                if (this.createCourseForm.knowledge.length == 0) {
                    isErrNum = 1;
                    await this.$message({
                        type: 'warning',
                        message: '请添加理论知识',
                        duration: 500,
                    })
                }
                if (this.createCourseForm.major.length == 0) {
                    isErrNum = 1;
                    await this.$message({
                        type: 'warning',
                        message: '请添加专业知识',
                        duration: 1000,
                    })
                }
                if (this.createCourseForm.appraisal_content.theoretical_knowledge_content == '') {
                    isErrNum = 1;
                }
                if (this.createCourseForm.appraisal_content.professional_skill_content == '') {
                    isErrNum = 1;
                }
                if (isErrNum == 0) {
                    this.$emit('changeStep', 2);
                    this.$emit('saveForm', this.createCourseForm);
                } else {
                    return
                }
            },
            goBack(formName) {
                this.$refs[formName].resetFields();
                this.$router.go(-1);
            }
        },
    }
</script>

<style scoped lang="scss">
    .form-content {
        padding: 20px 0;
        flex: 1;

        .el-input {
            width: 500px;
        }

        .c-input-width-80 {

            ::v-deep.el-input__inner {
                text-align: left;
            }
        }


        .el-textarea {
            width: 880px;

            ::v-deep textarea {
                resize: none;
            }
        }

        .cover-uploader {
            width: 880px;

            ::v-deep.el-upload {
                display: flex;
                align-items: center;

                .inner-box {
                    width: 200px;
                    height: 113px;
                    background: #F7F7F7;
                    border-radius: 2px;

                    .inner-content {
                        padding: 29px 0;
                        display: flex;
                        flex-direction: column;
                        color: #F23B2F;

                        i {
                            font-size: 24px;
                        }

                        .inner-text {
                            font-size: 16px;
                        }
                    }
                }

                .cover {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 200px;
                    height: 113px;
                    margin-left: 15px;
                    position: relative;

                    img {
                        width: 100%;
                        height: 100%;
                    }

                    .cover-bottom {
                        position: absolute;
                        bottom: 0;
                        width: 200px;
                        height: 32px;
                        background: #000000;
                        opacity: 0.5;
                        border-radius: 2px;
                        color: #ffffff;
                        font-size: 16px;
                        line-height: 36px;
                    }
                }

                .item-txt-tip {
                    margin-left: 19px;
                    color: #999999;
                }
            }
        }

        .form-title {
            width: 100%;
            height: 40px;
            background: #F5F7F6;
            display: flex;
            align-items: center;
            margin-bottom: 20px;

            .item-text {
                margin-left: 26px;
                font-size: 20px;
                color: #333333;
            }
        }

        .add-btn {
            margin-bottom: 12px;
            height: 40px;
            position: relative;

            .notice-title {
                font-size: 14px;
                color: #EB1515;
                position: absolute;
                left: 80px;
                top: 10px;
            }

            .btn-box {
                width: 94px;
                height: 40px;
                background: #F23B2F;
                border-radius: 2px;
                color: #ffffff;
                text-align: center;
                line-height: 2;
                cursor: pointer;
                position: absolute;
                right: 0;
                top: 0;
                display: flex;
                align-items: center;
                justify-content: center;

                i {
                    font-size: 14px;
                    margin-right: 5px;
                }
            }
        }

        .next-stepBtn {
            margin-left: 30px;
        }
    }
</style>